import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
// import DistanceCard from './Courses/DistanceCard'
import ImageWithSkeleton from '../../../../../components/ImageWithSkeleton'
import Grid from '@mui/material/Grid'
import { useState, useEffect } from 'react'
import CourseBrief from './CourseDetails/CourseBrief/_CourseBrief'
import CourseMap from './CourseDetails/CourseMap/_CourseMap'
import CheckpointsGuide from './CourseDetails/CheckpointsGuide/_CheckpointsGuide'
import Schedule from './Schedule/_Schedule'
import MandatoryGear from './MandatoryGear/_MandatoryGear'
import RecommendedGear from './RecommendedGear/_RecommendedGear'
import TravelAndParking from './TravelAndParking/_TravelAndParking'
import DropBagInfo from './DropBagInfo/_DropBagInfo'
import FinishPrizes from './FinishPrizes/_FinishPrizes'
import AidStationInfo from './AidStationInfo/_AidStationInfo'
import RaceVenueInfo from './RaceVenueInfo/_RaceVenueInfo'
import RaceInfo from './RaceInfo/_RaceInfo'
import RulesAndPenalties from './RulesAndPenalties/_RulesAndPenalties'
import TravelGuide from './TravelGuide/_TravelGuide'
import ControlledAccordions from './ControlledAccordions'
import { GUIDE_SECTION_GROUPS, isSectionVisible } from './guideSections'
import Sponsors from './Sponsors/_Sponsors'
import TrackingAndContacts from './TrackingAndContacts/TrackingAndContacts'
import EventIcon from '@mui/icons-material/Event'
import InfoIcon from '@mui/icons-material/Info'
import MapIcon from '@mui/icons-material/Map'
import CheckIcon from '@mui/icons-material/Check'
import HikingOutlinedIcon from '@mui/icons-material/HikingOutlined'
import RecommendIcon from '@mui/icons-material/Recommend'
import LuggageIcon from '@mui/icons-material/Luggage'
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined'
import CommuteIcon from '@mui/icons-material/Commute'
import LocalDrinkIcon from '@mui/icons-material/LocalDrink'
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms'
import BusinessIcon from '@mui/icons-material/Business'
import StadiumIcon from '@mui/icons-material/Stadium'
import PanToolAltIcon from '@mui/icons-material/PanToolAlt'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import RecordVoiceOverOutlinedIcon from '@mui/icons-material/RecordVoiceOverOutlined'
import Chatty from './_Components/Chatty'
import { useTranslation } from 'react-i18next'
import Updates from './Latest Update and Announcements/Updates.js'

// import Weather from '../../../../../components/Weather/Weather'

export default function Goat ({ race, category, item }) {
  const { t } = useTranslation('raceGuide')
  const [distance, setDistance] = useState(null)
  const [accordionExpanded, setAccordionExpanded] = useState({})

  // Handle category and item props for auto-selection
  useEffect(() => {
    if (category && item === 'interactive-map') {
      // Set the distance based on category
      setDistance(category)

      // Expand the course map accordion
      setAccordionExpanded({ courseMap: true })
    } else {
      const savedDistance = localStorage.getItem('selectedDistance')
    if (savedDistance) {
      setDistance(Number(savedDistance))
    }
    }
  }, [category, item])

  useEffect(() => {
    if (distance) {
      localStorage.setItem('selectedDistance', distance.toString())
    }
  }, [distance])

  const guidePanels = {
    updates: {
      icon: <RecordVoiceOverOutlinedIcon
        sx={{
          color: 'orange',
          animation: 'shakeAndPause 3.5s infinite',
          '@keyframes shakeAndPause': {
            '0%, 100%': { transform: 'translateX(0)' },
            '1.4%, 4.3%': { transform: 'translateX(-3px)' },
            '2.9%, 5.7%': { transform: 'translateX(3px)' },
            '7.1%, 100%': { transform: 'translateX(0)' }
          }
        }}
            />,
      title: t('sections.updates'),
      child: <Updates key='updates' />
    },
    schedule: { icon: <EventIcon />, title: t('sections.schedule'), child: <Schedule key='schedule' {...{ race, distance }} /> },
    courseBrief: { icon: <InfoIcon />, title: t('sections.courseBrief'), child: <CourseBrief key='course-brief' {...{ race, distance }} /> },
    courseMap: { icon: <MapIcon />, title: t('sections.courseMap'), child: <CourseMap key='course-map' {...{ race, distance, showMapDefault: item === 'interactive-map' }} /> },
    checkpointsGuide: { icon: <LocationOnIcon />, title: t('sections.checkpointsGuide'), child: <CheckpointsGuide key='checkpoints-guide' {...{ race, distance }} /> },
    mandatoryGear: { icon: <HikingOutlinedIcon />, title: t('sections.mandatoryGear'), child: <MandatoryGear key='mandatory-gear' {...{ race, distance }} /> },
    recommendedGear: { icon: <RecommendIcon />, title: t('sections.recommendedGear'), child: <RecommendedGear key='recommended-gear' {...{ race, distance }} /> },
    travelAndParking: { icon: <CommuteIcon />, title: t('sections.travelAndParking'), child: <TravelAndParking key='travel-parking' {...{ race, distance }} /> },
    dropBagInfo: { icon: <LuggageIcon />, title: t('sections.dropBagInfo'), child: <DropBagInfo key='drop-bag' {...{ race, distance }} /> },
    finishPrizes: { icon: <EmojiEventsOutlinedIcon />, title: t('sections.finishPrizes'), child: <FinishPrizes key='finish-prizes' {...{ race, distance }} /> },
    aidStationInfo: { icon: <LocalDrinkIcon />, title: t('sections.aidStationInfo'), child: <AidStationInfo key='aid-station' {...{ race }} /> },
    raceVenueInfo: { icon: <StadiumIcon />, title: t('sections.raceVenueInfo'), child: <RaceVenueInfo key='race-venue' {...{ race }} /> },
    raceInfo: { icon: <PanToolAltIcon />, title: t('sections.raceInfo'), child: <RaceInfo key='race-info' {...{ race }} /> },
    rulesAndPenalties: { icon: <CheckIcon />, title: t('sections.rulesAndPenalties'), child: <RulesAndPenalties key='rules-penalties' {...{ race }} /> },
    trackingAndContacts: { icon: <AccessAlarmsIcon />, title: t('sections.trackingAndContacts'), child: <TrackingAndContacts {...{ race }} /> },
    travelGuide: { icon: <BusinessIcon />, title: t('sections.travelGuide'), child: <TravelGuide key='travel-guide' {...{ race }} /> },
    sponsors: { icon: <RecommendIcon />, title: t('sections.sponsors'), child: <Sponsors key='sponsors' {...{ race }} opened /> }
  }

  const buildGuideGroup = (ids) => {
    const panels = ids
      .filter(id => guidePanels[id] && isSectionVisible(race?.guideSections, id))
      .map(id => ({ id, ...guidePanels[id] }))

    return {
      titles: panels.map(({ id, icon, title }) => ({ id, icon, title })),
      children: panels.map(({ child }) => child)
    }
  }

  const guideAccordionGroups = GUIDE_SECTION_GROUPS
    .map(buildGuideGroup)
    .filter(group => group.titles.length > 0)

  return (
    <>
      <Typography
        variant='h6' gutterBottom sx={{
        fontWeight: 'bold'
      }}
      >
        {t('raceGuide.title')}
      </Typography>
      {/* <Typography
        variant='h6'
        color='secondary'
        sx={{
          mt: 4,
          mb: 2
        }}
      >
        Select your category below!
      </Typography> */}
      <Grid container>
        {/* <Grid size={10} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'top' }}>
          <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', pt: 0 }}>
            {race?.raceDistances?.sort((a, b) => a.distance - b.distance).map((d) => (
              <Chip
                key={d.id}
                size='large'
                label={`${d.distance} km`}
                color='icon'
                sx={{
                  fontWeight: 600,
                  fontSize: '0.8rem',
                  backgroundColor: d?.color,
                  color: d.color === 'white' ? 'black' : 'white',
                  border: '2px solid transparent',
                  borderColor: d.distance === distance ? 'white' : 'transparent',
                  opacity: d.distance === distance ? 1 : 0.7
                }}
                onClick={() => {
                  navigate(`/races/${race.slug}/details`)
                  setDistance(d.distance)
                }}
              />
            ))}
          </Box>
          <Box
            sx={{
            mt: 2
          }}
          >
            {distance &&
              <Typography variant='h5'>{race?.raceDistances?.find(r => r.distance === distance)?.name}</Typography>}
          </Box>
        </Grid> */}

        {race?.guidePdf && (
          <Grid size={2}>
            <Box
              sx={{
                // mt: -5,
                cursor: 'pointer',
                '&:hover': {
                  opacity: 0.8
                },
                transition: 'all 0.2s ease',
                display: 'inline-block'
              }}
              onClick={() => window.open(race.guidePdf, '_blank')}
            >
              {race?.guideImage &&
                <ImageWithSkeleton oneSize src={race.guideImage} square maxWidth='160px' />}
              <Typography variant='caption'>{t('raceGuide.clickToDownload')}</Typography>
            </Box>
          </Grid>
        )}
      </Grid>
      {/* <Grid size={12}>
        <Weather {...{ location: race.locationForWeather, data: race.date }} />
      </Grid> */}
      {distance && (
        <>
          <Typography
            variant='h6'
            gutterBottom
            sx={{
              fontWeight: 'bold',
              mt: 3
            }}
          >
            {t('raceGuide.raceDetails')}
          </Typography>
          <ControlledAccordions
            accordions={guideAccordionGroups}
            initialExpanded={accordionExpanded}
          />
        </>
      )}

      {!['last-one-standing', 'last-1-standing-2026'].includes(race?.slug) && <Chatty {...{ distance }} />}

      {/* <Typography variant='h6' gutterBottom fontWeight='bold' mt={3}>
        Course Maps
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, py: 0 }}>
        {race?.raceDistances.map((distance) => (
          <DistanceCard key={distance.id} {...{ race, distance }} />
        ))}
      </Box> */}
    </>
  )
}
